/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'

import React from 'react'
import { Pressable, View, Icon, SearchTextField } from '@components/atoms'
import { FixedSizeGrid as Grid, GridChildComponentProps } from 'react-window'

import config from '@configs'
import { grey } from '@mui/material/colors'

interface PropsType {
	onIconClick: (iconName: string) => void
}

export const IconPicker = (props: PropsType) => {
	// state
	const [searchKeyword, setSearchKeyword] = React.useState<string>('')
	const [searchedIconList, setSearchedIconList] = React.useState<string[]>([])

	// variables
	const icons = React.useMemo(() => config.icons(), [])

	React.useEffect(() => {
		const newIcons =
			searchKeyword !== ''
				? icons.filter((anIcon: string) => anIcon.match(searchKeyword))
				: []
		setSearchedIconList(newIcons)
	}, [searchKeyword, icons])

	const onIconClick = React.useCallback((iconName: string) => {
		props.onIconClick(iconName)
	}, [])

	const onSearchChange = React.useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
		const str = e.target.value

		setSearchKeyword(str)
	}, [])

	const IconButton = (rowProps: GridChildComponentProps) => {
		const { data, columnIndex, rowIndex } = rowProps
		// eslint-disable-next-line @typescript-eslint/restrict-plus-operands
		const index: number = columnIndex + rowIndex * 10

		return (
			<View style={rowProps.style} key={data[index]} className="iconView">
				<Pressable className="iconButton" onClick={() => onIconClick(data[index])}>
					<Icon name={data[index]} />
				</Pressable>
			</View>
		)
	}

	return (
		<View css={style}>
			<View>
				<SearchTextField onChange={onSearchChange} />
			</View>

			{searchKeyword !== '' ? (
				<Grid
					columnCount={10}
					columnWidth={40}
					rowCount={searchedIconList.length / 10}
					rowHeight={40}
					height={400}
					width={406}
					itemData={searchedIconList}
					className="iconPickerGridView"
				>
					{IconButton}
				</Grid>
			) : null}
			<Grid
				css={searchKeyword !== '' ? { opacity: 0, maxHeight: 0 } : null}
				columnCount={10}
				columnWidth={40}
				rowCount={icons.length / 10}
				rowHeight={40}
				height={400}
				width={406}
				itemData={icons}
				className="iconPickerGridView"
			>
				{IconButton}
			</Grid>
		</View>
	)
}

const style = css({
	width: 410,
	height: '100%',
	overflowY: 'auto',
	overflowX: 'hidden',

	'.iconPickerGridView': {
		display: 'flex',
		alignItems: 'center',
		flexWrap: 'wrap',
		overflowX: 'hidden',

		'.iconView': {
			display: 'flex',
			justifyContent: 'center',
			alignItems: 'center',

			'.iconButton': {
				display: 'flex',
				justifyContent: 'center',
				alignItems: 'center',
				width: '100%',
				height: '100%',

				'&:hover': {
					background: grey[200],
				},
			},
		},
	},
})
